export const openSectionTutorialSteps = [
  {
    target: '[data-joyride-id="lcbOpenSectionButton"]',
    title: 'How to open Next Section?',
    content:
      'Select student cards using the checkboxes and click here to open the next section for the students.',
    disableBeacon: true,
  },
]
